<template>
        <span
                @mouseenter="setSelectedStyle"
                @mouseleave="setNormalStyle"
                v-bind:style="style" class="button clickable" v-bind:class="{'is-outlined': !selected}"  @click="toggleClick">{{category.name}}</span>
</template>
<script>

    import _ from 'lodash'

    export default {
        name: 'CategoryItem',
        components: {},
        props:['category', 'selected'],
        data() {
            return {
                normalStyle: {'color' : this.category.color, 'border-color' : this.category.color},
                selectedStyle: {'background-color' : this.category.color, 'color' : this.category.text_color},
                style: {}
            }
        },
        created(){
            if(!this.selected){
                this.setNormalStyle();
            }
            else{
                this.setSelectedStyle();
            }
        },
        mounted(){
        },
        methods: {
            toggleClick(){
                this.$emit('click', this.category);
            },
            setSelectedStyle(){
                this.style = this.selectedStyle;
            },
            setNormalStyle(){
                if(!this.selected) {
                    this.style = this.normalStyle;
                }
            },
        },
        watch: {
            'selected': function(val){
                if(!val){
                    this.setNormalStyle();
                }
                else{
                    this.setSelectedStyle();
                }
            }
        }

    }
</script>

<style lang="css" scoped>

        @media screen and (max-width: 768px){
                span.button{
                        width: 100%;
                        /*margin: 5px 0px;*/
                }
        }

</style>



// WEBPACK FOOTER //
// src/components/premade-comments/components/CategoryItem.vue